<script>
  export let hasHeader = false;
</script>

<div class='modal' style="z-index: 10;">
  <div class='modal__wrapper'>
    <div class='modal__background'></div>
    <div class='modal__box'>
      {#if hasHeader}
        <div class='modal__head'>
          <h2>
            <slot name="header"></slot>
          </h2>
        </div>
      {/if}
      <div class='modal__main'>
        <slot name="content"></slot>
        <div class='modal__main--btn center-xy'>
          <slot name="buttons"></slot>
        </div>
      </div>
    </div>
  </div>
</div>